import { useEffect, useState } from "react";
import {
  Space,
  Grid,
  Spin,
  message,
  Carousel,
  Image,
  Flex,
  Divider,
  List,
  Card,
  Button,
  Badge,
  Pagination,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import publicDataServices from "../../../APIs/publicDataServices";

import { settings } from "../../../Services/apiSetting";

import { toSlug } from "../../../Components/Common/helpers";

const { useBreakpoint } = Grid;

const PromotionDetails = () => {
  const screens = useBreakpoint();
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();

  const { promotionId, slug } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [promotion, setPromotion] = useState();
  const [promotionProducts, setPromotionProducts] = useState([]);

  let pageSizeVar = 8;

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: pageSizeVar,
    total: 0,
  });

  useEffect(() => {
    setIsLoading(true);

    const fetchPromotionDetails = async () => {
      try {
        const response = await publicDataServices.getPromotionDetails(
          parseInt(promotionId),
          slug
        );

        if (response.data.success) {
          const data = JSON.parse(response.data.data);

          console.log("Promotion details response data:", data);

          setPromotion(data);

          setPromotionProducts(data.Products || []);

          setPagination((prev) => ({
            ...prev,
            current: 1,
            pageSize: pageSizeVar,
            total: data.Products.length,
          }));
        }
      } catch (error) {
        console.error("Error fetching promotion details:", error);

        messageApi.error(
          error?.response?.data?.message ||
            error?.response?.data ||
            "Failed to fetch promotion details."
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchPromotionDetails();
  }, [slug]);

  return (
    <Space
      direction="vertical"
      className="page-container"
      style={{
        paddingBottom: 0,
        marginBottom: 0,
        minHeight: "80vh",
      }}
    >
      {contextHolder}

      {isLoading ? (
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          fullscreen
        />
      ) : (
        <>
          <Carousel autoplay arrows dots={false} infinite>
            {promotion?.ImagesTagList?.map((imageTagName, index) => (
              <Image
                key={index}
                src={settings.promoImageFolder + imageTagName.Name}
                alt={`Promotion Image ${index + 1}`}
                height={
                  screens.xs ? 150 : screens.xxl ? 450 : screens.lg ? 350 : 250
                }
                width="100%"
                style={{
                  borderRadius: 8,
                  border: "1px solid #e8e8e8 !important",
                  objectFit: "cover",
                }}
              />
            ))}
          </Carousel>

          <Divider
            style={{
              marginTop: 10,
              marginBottom: 10,
            }}
          />

          <Flex gap={12} wrap="wrap" align="center">
            <h2
              style={{
                marginTop: 0,
                marginBottom: 0,
              }}
            >
              {promotion?.Name}
            </h2>

            <p
              style={{
                fontSize: screens.xs ? 12 : 14,
              }}
            >
              <b>{dayjs(promotion?.StartDate).format("DD MMMM YYYY")}</b> -{" "}
              <b>{dayjs(promotion?.EndDate).format("DD MMMM YYYY")}</b>
            </p>
          </Flex>

          {/* Discount Badges */}
          <Flex gap={8} align="center" style={{ width: "100%" }}>
            {promotion?.DiscountPercent > 0 && (
              <div
                style={{
                  height: 21,
                  background: "#FFDC00",
                  color: "#fff",
                  padding: "2px 10px",
                  fontWeight: "bold",
                  zIndex: 1,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                  borderRadius: 4,
                  color: "black",
                }}
              >
                {promotion?.DiscountPercent}% OFF
              </div>
            )}

            {promotion?.FreeItem > 0 && promotion?.BuyQuantity > 0 && (
              <div
                style={{
                  height: 21,
                  background: "#FFDC00",
                  color: "#fff",
                  padding: "2px 10px",
                  fontWeight: "bold",
                  zIndex: 1,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                  borderRadius: 4,
                  color: "black",
                }}
              >
                Buy {promotion?.BuyQuantity} Free {promotion?.FreeItem}
              </div>
            )}
          </Flex>

          <List
            locale={{ emptyText: "No product(s) available." }}
            grid={{
              gutter: 16,
              xs: 1, // 1 column on extra small
              md: 2, // 2 columns on medium and up
              lg: 2, // 2 columns on large
              xl: 4, // 4 columns on extra large
              xxl: 4, // 4 columns on double extra large
            }}
            dataSource={promotionProducts.slice(
              (pagination.current - 1) * pagination.pageSize,
              pagination.current * pagination.pageSize
            )}
            renderItem={(item) => {
              return (
                <List.Item>
                  {(() => {
                    const card = (
                      <Card
                        styles={{
                          body: {
                            paddingTop: 10,
                            paddingBottom: 20,
                            width: "100%",
                            minWidth: 225,
                          },
                        }}
                        style={{
                          cursor: "initial",
                          marginTop: screens.xs ? 10 : 10,
                        }}
                        hoverable={false}
                        cover={
                          <Image
                            width={screens.xs || screens.md ? "100%" : 240}
                            height={200}
                            alt={item.name}
                            style={{ borderRadius: 4 }}
                            src={
                              settings.productImageFolder +
                              item.ImagesTagList[0].Name
                            }
                          />
                        }
                      >
                        <h2
                          style={{
                            margin: 0,
                            fontSize: 16,
                            color: "#002753",
                          }}
                        >
                          {item.ProductName}
                        </h2>

                        <p
                          style={{
                            margin: 0,
                            fontSize: 14,
                            color: "#6B7280",
                          }}
                        >
                          {item.Sku}
                        </p>

                        <Button
                          type="primary"
                          block
                          style={{
                            marginTop: 10,
                            backgroundColor: "#002753",
                            color: "#fff",
                          }}
                          className="view-details-btn"
                          onClick={() => {
                            navigate(
                              `/product-details/${item.Id}/${toSlug(
                                item.Sku
                              )}/${toSlug(item.ProductName)}`
                            );
                          }}
                        >
                          View Details
                        </Button>
                      </Card>
                    );

                    // wrap with ribbons
                    let wrapped = card;

                    if (item.RibbonText) {
                      wrapped = (
                        <Badge.Ribbon text={item.RibbonText} color="red">
                          {wrapped}
                        </Badge.Ribbon>
                      );
                    }

                    return wrapped;
                  })()}
                </List.Item>
              );
            }}
          />

          <Flex justify="center" style={{ marginBottom: 30 }}>
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={(page, pageSize) => {
                setPagination((prev) => ({
                  ...prev,
                  current: page,
                  pageSize: pageSize,
                }));

                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </Flex>

          <Flex
            wrap="wrap"
            justify="center"
            align="center"
            className="no-margin-box"
            style={{ backgroundColor: "#F9FAFB" }}
          >
            <p
              style={{
                color: "#002753",
                fontSize: screens.md ? 24 : 28,
                fontWeight: "bold",
                textAlign: "center",
                marginTop: 40,
                marginBottom: 20,
                width: "100%",
              }}
            >
              Have questions about our promotions?
            </p>

            <Button
              type="primary"
              style={{
                backgroundColor: "#002753",
                borderColor: "#002753",
                color: "white",
                padding: 20,
                marginBottom: 40,
              }}
              onClick={() => navigate("/contact-us")}
            >
              Get in Touch
            </Button>
          </Flex>
        </>
      )}
    </Space>
  );
};

export default PromotionDetails;
